import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { clientsList } from '../../data/mock';
import { ScrollReveal } from '../ui/ScrollReveal';

const TrustedPartnersSection = () => {
  return (
    <section id="partners" className="pt-8 sm:pt-10 md:pt-12 pb-12 sm:pb-16 md:pb-24 bg-[#FAF8F2] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal variant="fadeUp" threshold={0.2}>
          <div className="text-center mb-8 sm:mb-10 md:mb-12">
            <span className="text-[#8B7355] text-xs sm:text-sm font-semibold tracking-widest uppercase">Trusted Partners</span>
            <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-[#1A1A1A] mt-2 sm:mt-3">
              Working with industry leaders
            </h2>
            <p className="text-[#6B6B65] text-base sm:text-lg mt-3 sm:mt-4 max-w-2xl mx-auto px-4">
              Partnering with India's leading industrial companies for over two decades of excellence.
            </p>
          </div>
        </ScrollReveal>

        <ScrollReveal variant="fadeUp" threshold={0.1} delay={0.2}>
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4 md:gap-6 lg:gap-8 items-center px-4">
            {clientsList.map((client, index) => (
              <React.Fragment key={client.id}>
                <motion.span
                  className="text-[#1A1A1A] text-xs sm:text-sm md:text-base font-medium"
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                >
                  {client.name}
                </motion.span>
                {index === clientsList.length - 1 ? (
                  <>
                    <span className="text-[#8B7355] mx-1.5 sm:mx-2">•</span>
                    <Link
                      to="/clients"
                      className="inline-flex items-center gap-1.5 sm:gap-2 text-xs sm:text-sm md:text-base text-[#8B7355] font-medium hover:text-[#7A6348] transition-colors group"
                    >
                      See more
                      <ArrowUpRight className="w-3.5 h-3.5 sm:w-4 sm:h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                    </Link>
                  </>
                ) : index < clientsList.length - 1 && (
                  <span className="text-[#8B7355] mx-1.5 sm:mx-2">•</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default TrustedPartnersSection;
